import Service from '../../services'
import Swal from "sweetalert2";
// initial state
const state = {
    tsicForm: {
        tsic_code: '',
        tsic_name_th: '',
        tsic_name_en: '',
    },
    industryForm: {
        name_th: '',
        name_en: '',
        description_th: '',
        description_en: '',
        icon_path: '',
        status: 0,
        industry_tsic: []
    },

    allTsic: [],
    allTsicPaginate: {},
    allIndustries: [],
    allIndustriesPaginate: {}
};


// getters
const getters = {

    industryOption: (state) => {
        let industry = [];
        for (let i = 0; i < state.allIndustries.length; i++) {
            industry.push({
                id: state.allIndustries[i].id,
                text_th: state.allIndustries[i].name_th
            });
        }
        return industry;
    },

    tsicOption: (state) => {
        let tsic = [];
        for (let i = 0; i < state.allTsic.length; i++) {
            tsic.push({
                tsic_id: state.allTsic[i].tsic_id,
                text: state.allTsic[i].tsic_code + ' - ' + state.allTsic[i].activity_name_th
            });
        }
        return tsic;
    }

};


// actions
const actions = {

    // tsic
    onGetAllTsic({ commit }, data) {
        return Service.tsic.getAllTsic(data).then((res) => {
            commit('setAllTsic', res);
        })
    },

    onGetAllTsicPaginate({ commit }, data) {
        return Service.tsic.getAllTsicPaginate(data).then((res) => {
            // console.log(res)
            commit('setAllTsicPaginate', res);
        });
    },

    onGetTsic({ commit }, data) {
        return Service.tsic.getTsic(data).then((res) => {
            commit('setTsic', res);
        });
    },

    onCreateTsic({ commit }, data) {
        return Service.tsic.createTsic(data).then(() => {
            Swal.fire({
                icon: 'success',
                title:'สำเร็จ!',
                text: 'เพิ่มข้อมูลสำเร็จ',
            })
            // alert('เพิ่มข้อมูลสำเร็จ');
        });
    },

    onEditTsic({ commit }, data) {
        return Service.tsic.editTsic(data).then(() => {
            Swal.fire({
                icon: 'success',
                title:'สำเร็จ!',
                text: 'แก้ไขข้อมูลสำเร็จ',
            })
            // alert('แก้ไขข้อมูลสำเร็จ');
        });
    },

    onDeleteTsic({ commit }, data) {
        return Service.tsic.deleteTsic(data).then(() => {
            Swal.fire({
                icon: 'success',
                title:'สำเร็จ!',
                text: 'ลบข้อมูลสำเร็จ',
            })
            // alert('ลบข้อมูลสำเร็จ');
        });
    },


    // Industry
    onGetAllIndustries({ commit }, data) {
        return Service.tsic.getAllIndustries(data).then((res) => {
           commit('setAllIndustries', res);
        });
    },

    onGetAllIndustriesPaginate({ commit }, data) {
        return Service.tsic.getAllIndustriesPaginate(data).then((res) => {
            // console.log(res)
            commit('setAllIndustriesPaginate', res);
        });
    },

    onGetIndustry({ commit }, data) {
        return Service.tsic.getIndustry(data).then((res) => {
            commit('setIndustry', res);
        });
    },

    onCreateIndustry({ commit }, data) {
        return Service.tsic.createIndustry(data).then(() => {
            Swal.fire({
                icon: 'success',
                title:'สำเร็จ!',
                text: 'เพิ่มข้อมูลสำเร็จ',
            })
            // alert('เพิ่มข้อมูลสำเร็จ');
        });
    },

    onEditIndustry({ commit }, data) {
        return Service.tsic.editIndustry(data).then(() => {
            Swal.fire({
                icon: 'success',
                title:'สำเร็จ!',
                text: 'แก้ไขข้อมูลสำเร็จ',
            })
            // alert('แก้ไขข้อมูลสำเร็จ');
        });
    },

    onDeleteIndustry({ commit }, data) {
        return Service.tsic.deleteIndustry(data).then(() => {
            Swal.fire({
                icon: 'success',
                title:'สำเร็จ!',
                text: 'ลบข้อมูลสำเร็จ',
            })
            // alert('ลบข้อมูลสำเร็จ');
        });
    }

};


// mutations
const mutations = {

    // TSIC
    setAllTsic(state, data) {
        state.allTsic = data;
    },

    setAllTsicPaginate(state, data) {
        state.allTsicPaginate = data;
    },

    setTsic(state, data) {
        state.tsicForm = {
            tsic_code: data.tsic_code,
            tsic_name_th: data.activity_name_th,
            tsic_name_en: data.activity_name_en
        };
    },


    // Industry
    setAllIndustries(state, data) {
      state.allIndustries = data;
    },

    setAllIndustriesPaginate(state, data) {
        state.allIndustriesPaginate = data;
    },

    setIndustry(state, data) {
        state.industryForm = {
            name_th: data.name_th,
            name_en: data.name_en,
            icon_path: data.icon_path,
            status: data.status,
            description_th: data.description_th,
            description_en: data.description_en,
            industry_tsic: data.industry_tsic
        };
    }

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
